import { Trans } from 'react-i18next'

import { NS } from 'src/constants/i18n'

type TimelineDescriptionProps = {
  providerName?: string | null
  isScheduled: boolean
  isMultiTrip: boolean
  isCompleted: boolean
  firstDate?: string
  lastDate?: string
}

const SEMIBOLD_COMPONENT = <strong className="font-semibold" />
const LINE_BREAK_COMPONENT = <br />

export const TimelineDescription = ({
  providerName,
  isScheduled,
  isMultiTrip,
  isCompleted,
  firstDate,
  lastDate,
}: TimelineDescriptionProps) => {
  let translationKey: string

  // 1. Not scheduled yet
  if (!isScheduled) {
    translationKey = providerName ? 'pendingWithProvider' : 'pending'
  } else if (isMultiTrip && isCompleted) {
    // 2. Multi trip scheduled: completed
    translationKey = 'completedMultiTrip'
  } else if (isMultiTrip) {
    // 3. Multi trip scheduled: not completed/in progress
    translationKey = lastDate ? 'multiTrip' : 'multiTripFirst'
  } else if (isCompleted) {
    // 4. Single trip scheduled: completed
    translationKey = 'completedSingleTrip'
  } else {
    // 5. Single trip scheduled: not completed
    translationKey = 'singleTrip'
  }

  return (
    <Trans
      i18nKey={`${NS.TRACKING}:timeline.serviceScheduled.${translationKey}`}
      values={{ name: providerName, date: firstDate, firstDate, lastDate }}
      components={{ strong: SEMIBOLD_COMPONENT, br: LINE_BREAK_COMPONENT }}
    />
  )
}
